<template>
	<section class="tp-ongoing__table">
		<ClientOngoingTableReact
			:repairs="innerData"
			:loading="loading"
			:previsionDates="previsionDates"
			:onApproveQuotation="approveQuotationBtnHandler"
			:onRejectQuotation="rejectQuotationHandler"
		/>
	</section>
</template>

<script>
import { isNil } from "lodash";
import { mapActions } from "vuex";
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { ClientOngoingTable } from "@/components/client/ClientOngoingTable";

const ClientOngoingTableReact = ReactInVue(ClientOngoingTable);

export default {
	components: {
		ClientOngoingTableReact,
	},
	props: {
		data: {
			type: Array,
			default: () => [],
		},
	},

	data() {
		return {
			loading: false,
			tec: "",
			rep: [],

			previsionDates: {},
			innerData: null,
			logs: [],
		};
	},

	watch: {
		data() {
			this.preprocessData();
		},
	},

	created() {
		this.preprocessData();
	},

	methods: {
		...mapActions(["approveQuotation", "rejectQuotation"]),

		showQuotationMessage(entry) {
			// get the last quotation entry from the logs
			for (let i = entry.logs.length - 1; i > 0; i--) {
				const logEntry = entry.logs[i];
				if (logEntry.type === "quotation_set") {
					return logEntry.content;
				}
			}
			return "-";
		},

		repairTime(entry) {
			const repTime = this.logsFilter(entry.logs || []);

			if (repTime.split("-")[1] === undefined) {
				return "-";
			}
			let finalMessage = repTime.split("-")[1].trim();
			const observation = repTime.split("-").splice(2).join("-").trim();

			if (observation && observation.length > 9) {
				finalMessage += ` - ${observation}`;
			}
			return finalMessage;
		},
		/**
		 * Approve the quotation.
		 */
		approveQuotationBtnHandler(item) {
			// request confirmation to the user
			this.$confirm("Pretende aprovar o orçamento?", "Confirmação")
				.then((_) => {
					// enter in loading mode
					this.loading = true;

					// call the service to store the data permanently
					return this.approveQuotation([item.id, item.value || item.quotation]);
				})
				.then((_) => {
					// inform update
					this.$emit("update");

					// exit from the loading mode
					this.loading = false;

					// show a success message
					this.$message.success("Orçamento aprovado!");

					// Reload data
					this.fetchPage();
				})
				.catch((_) => {});
		},

		/**
		 * Reject quotation.
		 */
		rejectQuotationHandler(repair) {
			// request confirmation to the user
			this.$confirm("Pretende recusar o orçamento?", "Confirmação")
				.then((_) => {
					// enter in loading mode
					this.loading = true;

					// call the service to store the data permanently
					return this.rejectQuotation(repair.id);
				})
				.then((_) => {
					// inform update
					this.$emit("update");

					// exit from the loading mode
					this.loading = false;

					// show a success message
					this.$message.success("Orçamento recusado!");

					// Reload data
					this.fetchPage();
				})
				.catch((_) => {});
		},
		async previsionDate(item) {
			// get material requests for a given repair
			const { requests } = await this.$stellar.action(
				"materialRequestsForRepair",
				{
					repair: item.id,
				},
			);

			let purchaseDate = new Date(item.createdAt);
			const allDates = requests
				.filter((request) => request.purchase)
				.map((request) => {
					// get the purchase object
					const purchase = request.purchase;
					purchaseDate = new Date(purchase.createdAt);
					let tempDate = new Date();
					if (purchase.createdAt !== null) {
						if (purchase.origin === "europe") {
							tempDate.setDate(purchaseDate.getDate() + 4);
						} else {
							tempDate.setDate(purchaseDate.getDate() + 6);
						}
					} else {
						tempDate = new Date(purchase.createdAt);
					}

					return tempDate;
				});

			if (allDates.length === 0) {
				allDates.push(new Date(purchaseDate).getTime());
			}

			const higherDate = Math.max(...allDates);

			const message = this.logsFilter(item.logs);

			let date = null;

			try {
				date = message.split("-")[1].trim();
			} catch (e) {
				this.previsionDates[item.id] = "-";
				return;
			}
			const newDate = new Date(higherDate);

			if (date) {
				if (date === "Um dia") {
					newDate.setDate(newDate.getDate() + 1);
				}
				if (date === "Uma semana") {
					newDate.setDate(newDate.getDate() + 7);
				}
				if (date === "Duas semanas") {
					newDate.setDate(newDate.getDate() + 14);
				}
				if (date === "4 a 7 semanas") {
					newDate.setMonth(newDate.getMonth() + 1);
					newDate.setDate(newDate.getDate() + 21);
				}
				if (newDate.getDay() === 6) {
					newDate.setDate(newDate.getDate() + 2);
				}
				if (newDate.getDay() === 0) {
					newDate.setDate(newDate.getDate() + 1);
				}
				this.previsionDates[item.id] = `${newDate.getDate()}/${
					newDate.getMonth() + 1
				}/${newDate.getFullYear()}`;
			} else {
				this.previsionDates[item.id] = "-";
			}

			const copy = this.innerData;
			this.innerData = null;
			this.$nextTick((_) => {
				this.innerData = copy;
			});
		},

		async preprocessData() {
			this.innerData = this.data;
			for (const repair of this.data) {
				this.previsionDate(repair);
			}
		},
		logsFilter(item) {
			// There is some old repairs that don't have logs so we need to create an work around
			if (isNil(item)) {
				return "-";
			}

			const repLogs = item.filter(
				(itemLog) => itemLog.type === "repair.quotation",
			);
			if (!repLogs[0]) {
				return " - ";
			}
			return repLogs[0].message;
		},
	},
};
</script>
